"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderIntentSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const mongo_1 = require("../utility/mongo");
const constants_1 = require("../../constants");
const geography_1 = require("../utility/geography");
exports.OrderIntentSchema = joi_1.default.object({
    _id: mongo_1.ObjectIdSchema,
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    status: joi_1.default.string().allow('unpaid', 'unsubmitted', 'submitted').required(),
    uuid: joi_1.default.string().uuid().required(),
    billingInfo: joi_1.default.object({
        address: joi_1.default.object({
            city: joi_1.default.string(),
            country: joi_1.default.string().required(),
            line1: joi_1.default.string().required(),
            postalCode: joi_1.default.string().required(),
            state: joi_1.default.string().allow(null)
        }).required(),
        email: joi_1.default.string()
            .email({ tlds: { allow: !constants_1.isBrowser } })
            .required(),
        name: joi_1.default.string().required(),
        vatNumber: joi_1.default.string().allow(null)
    }).required(),
    attachmentUrl: joi_1.default.string().allow(null, ''),
    externalId: joi_1.default.string().allow(null),
    photoshootInstructions: joi_1.default.string().allow(null, ''),
    appointmentDetails: joi_1.default.string().allow(null, ''),
    location: geography_1.LocationSchema.required(),
    host: joi_1.default.object({
        email: joi_1.default.string()
            .email({ tlds: { allow: !constants_1.isBrowser } })
            .allow(null),
        name: joi_1.default.string().required(),
        phone: joi_1.default.string().required()
    }).allow(null),
    productUuid: joi_1.default.string().uuid().required(),
    orderUuid: joi_1.default.string().uuid().allow(null),
    paymentUrl: joi_1.default.string().uri().allow(null),
    paymentIntentId: joi_1.default.string().allow(null)
}).meta({ className: 'OrderIntent' });
//# sourceMappingURL=OrderIntentSchema.js.map